export const getDepthChoices = () => {
  return [
    { id: 500, name: 'Up to 500 URLs' },
    { id: 5000, name: 'Up to 5000 URLs (recommended)' },
    { id: 15000, name: 'Up to 15000 URLs' },
  ];
};
